export const IMAGE_SIZE_PRESETS = {
  xsmall: '50px',
  tiny: '100px',
  mini: '150px',
  small: '300px',
  medium: '600px',
  large: '100%',
} as const

export type ImageSizePreset = keyof typeof IMAGE_SIZE_PRESETS | 'custom'

export function normalizeImageWidth(value?: string | number | null): string {
  if (value === undefined || value === null || value === '') {
    return 'auto'
  }

  if (typeof value === 'number') {
    return `${value}px`
  }

  const trimmed = value.trim()
  if (!trimmed) return 'auto'
  if (/^\d+(\.\d+)?$/.test(trimmed)) return `${trimmed}px`
  return trimmed
}

export function resolveImageWidgetWidth(
  sizePreset?: string,
  customWidth?: string | number | null,
): string {
  if (sizePreset && sizePreset !== 'custom' && sizePreset in IMAGE_SIZE_PRESETS) {
    return IMAGE_SIZE_PRESETS[sizePreset as keyof typeof IMAGE_SIZE_PRESETS]
  }

  if (customWidth !== undefined && customWidth !== null && customWidth !== '') {
    return normalizeImageWidth(customWidth)
  }

  return 'auto'
}
